import { AxiosPromise } from 'axios';
import axios from 'axios';
import {
  ICampusSettingReq,
  ICheckUri,
  IGetCampus,
  IGetCampuses,
  IGetCampusSetting,
  IGetPgSetting,
  IGetVanSetting,
  IPgSettingReq, IVanSettingReq,
} from '../models/campuses.model';

const uri = '/mgmt/campuses';

export const checkCampusUrl = (campusUrl: string): AxiosPromise<ICheckUri> => {
  return axios.get(`${uri}/urlCheck/${campusUrl}`);
};

export const getCampus = (campusCode: string): AxiosPromise<IGetCampus> => {
  return axios.get(`${uri}/${campusCode}`);
};

export const getCampuses = (): AxiosPromise<IGetCampuses> => {
  return axios.get(`${uri}`);
};

export const createCampus = (data: any): AxiosPromise => {
  return axios.post(uri, data);
};

export const updateCampus = (campusCode: string, data: any): AxiosPromise => {
  return axios.put(`${uri}/${campusCode}`, data);
};

// 캠퍼스 > 환경설정
export const getCampusSetting = (campusCode: string): AxiosPromise<IGetCampusSetting> => {
  return axios.get(`${uri}/setting/${campusCode}`);
};

export const updateCampusSetting = (campusCode: string, data: ICampusSettingReq): AxiosPromise => {
  return axios.post(`${uri}/setting/${campusCode}`, data);
};

export const getPgSetting = (campusCode: string): AxiosPromise<IGetPgSetting> => {
  return axios.get(`${uri}/setting/${campusCode}/pg-setting`);
};

export const updatePgSetting = (campusCode: string, data: IPgSettingReq): AxiosPromise => {
  return axios.post(`${uri}/setting/${campusCode}/pg-setting`, data);
};

export const getVanSetting = (campusCode: string): AxiosPromise<IGetVanSetting> => {
  return axios.get(`${uri}/setting/${campusCode}/van-setting`);
};

export const updateVanSetting = (campusCode: string, data: IVanSettingReq): AxiosPromise => {
  return axios.post(`${uri}/setting/${campusCode}/van-setting`, data);
};